import type { SVGProps } from 'react';

export function EggIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.714 2.596c.659-.345 1.27.308 1.057 1.02L9.542 7.713l-.029.123a1 1 0 0 0 .406.978l2.029 1.449a1 1 0 0 1 .287 1.31l-1.103 1.931a1 1 0 1 0 1.736.992l2-3.5.052-.105a1 1 0 0 0-.339-1.205l-2.336-1.67a1 1 0 0 1-.377-1.1L13 3.144c.158-.527.717-.833 1.208-.584C17.431 4.195 20 9.15 20 14.083c0 4.59-3.273 7.71-8 7.917-4.75 0-8-3.21-8-7.917C4 9.188 6.528 4.265 9.714 2.596" />
    </svg>
  );
}
